<template>
  <div class="login">
    <div class="login-form">
      <el-form
        ref="ruleFormRef"
        style="max-width: 600px"
        :model="ruleForm"
        :rules="rules"
        label-width="auto"
      >
        <el-form-item>
          <h3 class="title">| 用户登陆</h3>
        </el-form-item>
        <el-form-item label="手机号" prop="acount">
          <el-input v-model="ruleForm.acount" placeholder="账号" />
        </el-form-item>
        <el-form-item label="密 码" prop="password">
          <el-input v-model="ruleForm.password" type="password" placeholder="密码" />
        </el-form-item>
        <el-form-item label="" prop="agreement">
          <el-checkbox-group v-model="ruleForm.agreement">
            <el-checkbox value="Online activities" name="type">
              我已阅读并同意：服务协议、个人信息保护政策。
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm(ruleFormRef)">
            登录
          </el-button>
        </el-form-item>
        <div class="flex flex-b">
          <p>去注册</p>
          <p>忘记密码</p>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  getCurrentInstance,
} from "vue";
const ruleForm = reactive({
  acount: "",
  password: "",
  agreement: "",
});
const rules = reactive({
  acount: [
    { required: true, message: "Please input Activity name", trigger: "blur" },
    { min: 3, max: 5, message: "Length should be 3 to 5", trigger: "blur" },
  ],
  password: [
    { required: true, message: "Please input Activity name", trigger: "blur" },
    { min: 3, max: 5, message: "Length should be 3 to 5", trigger: "blur" },
  ],
  agreement: [
    {
      type: "array",
      required: true,
      message: "Please select at least one activity type",
      trigger: "change",
    },
  ],
});
onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
});
onMounted(() => {
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
});
watchEffect(() => {});
// 使用toRefs解构
// let { } = { ...toRefs(data) }
defineExpose({});
</script>
<style scoped lang='scss' scope>
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100% !important;
  background-color: #ccc;
  padding: 50px 0;
  .login-form {
    border-radius: 6px;
    background: #fff;
    width: 430px;
    padding: 25px 25px 10px 25px;
  }
  .el-button {
    width: 100%;
  }
}
</style>